export default class LocaleHelper {
  
  public static getCalendarLocale(lngCode: string) {

    switch(lngCode) {
      case "hu" : {
        return { "firstDayOfWeek": 1,
        "dayNames": ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
        "dayNamesShort": ["Vas", "Hét", "Kedd", "Szer", "Csüt", "Pént", "Szom"],
        "dayNamesMin": ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
        "monthNames": ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
        "monthNamesShort": ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"] }
      }
      case "uk": {
        return { "firstDayOfWeek": 1,
        "dayNames": ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
        "dayNamesShort": ["Vas", "Hét", "Kedd", "Szer", "Csüt", "Pént", "Szom"],
        "dayNamesMin": ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
        "monthNames": ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
        "monthNamesShort": ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"] }
      }
      case "en": {
        return { "firstDayOfWeek": 1,
        "dayNames": ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
        "dayNamesShort": ["Vas", "Hét", "Kedd", "Szer", "Csüt", "Pént", "Szom"],
        "dayNamesMin": ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
        "monthNames": ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
        "monthNamesShort": ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"] }
      }
    }
  }
  
}
